import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

import { AnalyticsService } from '../analytics/analytics.service';
import { AuthService } from '../auth/auth.service';


/** Factory que cria e inicializa o NavigationService */
export function navigationServiceFactory(navigationService: NavigationService) {
    return () => navigationService.init();
}

@Injectable({
    providedIn: 'root'
})
/** Service para armazenar o histórico das últimas navegações da aplicação e disponibilizar funcionalidades de navegações */
export class NavigationService {
    private history: string[];

    constructor(private router: Router, private location: Location, private analytics: AnalyticsService, private authService: AuthService) { }

    /** Inicia o serviço de navegação registrando-se no evento de NavigationEnd do Router */
    init() {
        this.history = [];
        this.analytics.init();

        if (this.authService.isAuth) {
            this.analytics.setUserProfile(this.authService.getPerfilUsuario());
        }

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.history.push(event.urlAfterRedirects);
                this.analytics.trackPageView(event.urlAfterRedirects);

                // Se possuir mais de 2 rotas no histórico removemos a primeira para manter o array de histórico pequeno somente com as 2 últimas rotas
                if (this.history.length > 2) {
                    this.history.splice(0, 1);
                }
            }
        });
    }

    /** Retorna a navegação para o rota anterior */
    back(): void {
        this.history.pop();
        if (this.history.length > 0) {
            this.location.back()
        } else {
            this.router.navigateByUrl('/')
        }
    }
}
